export default "__VITE_ASSET__BPYpL1XV__"